import module from 'finanzas/module.js'
import template from './template.html'
import * as moment from 'moment'

const agrupar = (data, filtro) => {
  if (!data) return

  const grupos = {}
  const resultados = []

  data = data.filter((item) => item.id_moneda === +filtro.moneda)
  if (filtro.q) {
    let q = filtro.q.toLowerCase()
    data = data.filter((item) => item.colaborador.toLowerCase().contains(q))
  }

  data.forEach((item) => {
    let config = filtro.agrupacion === 1
      ? [item.proyecto, item.concepto]
      : [item.concepto, item.proyecto]

    if (!grupos[config[0]]) {
      grupos[config[0]] = {
        object: {},
        array: {data: [], total: 0, id: config[0]},
      }
      resultados.push(grupos[config[0]].array)
    }

    if (!grupos[config[0]].object[config[1]]) {
      grupos[config[0]].object[config[1]] = {
        object: {},
        array: {data: [], total: 0, id: config[1]},
      }
      grupos[config[0]].array.data.push(grupos[config[0]].object[config[1]].array)
    }

    grupos[config[0]].array.total += item.adeudo
    grupos[config[0]].object[config[1]].array.total += item.adeudo
    grupos[config[0]].object[config[1]].array.data.push(item)
  })

  return resultados
}

export class FinanzasSaldoempleados {
  proyectos
  fechaCorte
  data
  catalogo = {
    proyecto: [],
    moneda: [
      {id: 1, descripcion: 'MXN'},
      {id: 2, descripcion: 'USD'},
    ],
    agrupacion: [
      {id: 1, descripcion: 'Proyecto'},
      {id: 2, descripcion: 'Concepto'},
    ],
  }
  filtro = {
    agrupacion: 1,
    moneda: 1,
    q: '',
  }

  constructor ($catalogos, $q, $state, FinanzasSaldoEmpleados) {
    this.$catalogos = $catalogos
    this.$q = $q
    this.$state = $state
    this.FinanzasSaldoEmpleados = FinanzasSaldoEmpleados
  }

  $onInit () {
    let promise = []

    promise.push(this.$catalogos.get('empresas').then((data) => this.catalogo.proyecto = data.map((i) => ({id: i.ID_Empresa, descripcion: i.Nombre}))))

    if (this.proyectos.length && this.fechaCorte) {
      promise.push(this.FinanzasSaldoEmpleados.get(this.proyectos, this.fechaCorte).then(({data}) => this.data = data))
    }

    this.promise = this.$q.all(promise).then(() => this.agrupar())
  }

  buscar () {
    if (this.proyectos.length === 0) {
      alert('Es necesario seleccionar al menos un proyecto')
    } else {
      this.$state.go(this.$state.current, {
        proyectos: this.proyectos,
        fecha_corte: moment(this.fechaCorte).format('YYYY-MM-DD'),
      })
    }
  }

  agrupar () {
    this.results = agrupar(this.data, this.filtro)
  }
}

module.component('finanzasSaldoempleados', {
  controller: FinanzasSaldoempleados,
  template,
  bindings: {
    proyectos: '<',
    fechaCorte: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/saldoempleados/component.js